import { Routes } from '@angular/router';

import { BillAccountTermsComponent } from './bill-account-terms';
import { GoPaperlessTermsComponent } from './go-paperless-terms';
// Guards
import { KnowYourDriveSmartphoneTermsComponent } from './know-your-drive-smartphone-terms/know-your-drive-smartphone-terms.component';
import { KnowYourDriveTermsComponent } from './know-your-drive-terms';
import { BillAccountTermsGuard } from './shared/bill-account-terms-guard';

export const TermsRoutes: Routes = [
  {
    path: 'terms',
    data: { breadcrumb: 'Terms & Conditions' },
    children: [
      { path: '', redirectTo: 'go-paperless', pathMatch: 'full' },
      {
        path: 'go-paperless',
        component: GoPaperlessTermsComponent,
        data: {
          breadcrumb: 'Go Paperless Terms & Conditions'
        }
      },
      {
        path: 'know-your-drive',
        component: KnowYourDriveTermsComponent,
        data: {
          breadcrumb: 'KnowYourDrive Terms & Conditions'
        }
      },
      {
        path: 'know-your-drive-smartphone',
        component: KnowYourDriveSmartphoneTermsComponent,
        data: {
          breadcrumb: 'KnowYourDrive Smartphone Terms & Conditions'
        }
      }
    ]
  },
  {
    path: 'terms/billing',
    component: BillAccountTermsComponent,
    canDeactivate: [BillAccountTermsGuard],
    data: { breadcrumb: 'Billing Terms & Conditions' }
  }
];

export const TermsRoutingGuards = [BillAccountTermsGuard];
